import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=fc62954c&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"
import style0 from "./Rules.vue?vue&type=style&index=0&id=fc62954c&prod&scoped=true&lang=css"
import style1 from "./Rules.vue?vue&type=style&index=1&id=fc62954c&prod&lang=css"
import style2 from "./Rules.vue?vue&type=style&index=2&id=fc62954c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc62954c",
  null
  
)

export default component.exports